<div class="flex flex-col relative">
  @if (viewModel?.label || label) {
    <label
      [for]="id"
      class="ml-2 text-xs font-semibold text-lightText"
    >
      {{ viewModel?.label || label }}
    </label>
  }
  <input
    [id]="id"
    [name]="id"
    [type]="type"
    class="p-2 h-[41px] placeholder:text-sm rounded-xl placeholder:md:text-left focus:outline-none border"
    [style.border-color]="isValid ? '#9AA0A6' : '#E60012'"
    [placeholder]="viewModel?.placeholder || viewModel?.label || placeholder || label || ''"
    [value]="viewModel ? viewModel.value : value"
    (input)="inputHandler($event)"
    (blur)="blurHandler($event)"
  />
  @if (!isValid) {
    <span class="ml-2 text-xs text-toyotaRed font-semibold absolute top-[57px]">{{ errorMessage }}</span>
  }
</div>
